import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setMessages } from "../features/chat/chatSlice"
import { getAllMessagesRoute } from "../utils/API_Routes"
import useAxiosPrivate from "./usePrivateRoute"
import { v4 as uuid } from 'uuid'

const useMessages = (messages, pageNum) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const [isNew, setIsNew] = useState(false);
    const [hasNextPage, setHasNextPage] = useState(false);
    const { user } = useSelector((state) => state.user);
    const { currentChat } = useSelector(state => state.chat);
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        const controller = new AbortController()
        const { signal } = controller
        setIsLoading(true);
        const getMessages = async () => {
            return await axiosPrivate.get(`${getAllMessagesRoute}/${user._id}?to=${currentChat._id}&page=${pageNum}`, { signal })
        }
        getMessages().then((res) => {
            const response = res?.data.map((msg, i) => {
                return { ...msg, uid: uuid() }
            })
            dispatch(setMessages([...response, ...messages]))
            setHasNextPage(res?.data[res.data.length - 1]?.page <= res?.data[res?.data?.length - 1]?.last_page)
            setIsLoading(false)
        }).catch((err) => {
            setIsLoading(false);
            if (controller.abort) return;
            setIsError(true);
        })
        return () => controller?.abort();
    }, [pageNum, isNew, user._id])

    return { isLoading, isError, hasNextPage, isNew, setIsNew }
}

export default useMessages